import styled, { createGlobalStyle } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

export const TooltipItem = styled(FlexColumn)`
    margin-right: 20px;
    text-align: right;

    &:first-child {
        text-align: left;
    }

    &:last-child {
        margin: 0;
    }
`;

export const ItemTitle = styled.p`
    margin: 0;
    padding-bottom: 12px;
    ${setFontVariant("listItem3", colorsPalettes.carbon[400])}
    white-space: nowrap;
`;

export const ItemValue = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const TooltipGlobalStyle = createGlobalStyle`
  .PlainTooltip-element-white.top:before {
    border-top: 8px solid #d4d8dc;
  }
`;
